import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ToolsService} from '../../tools/tools.service';

@Injectable({
  providedIn: 'root'
})
export class GameWordService {

  constructor(
    private http: HttpClient,
    private toolsSrv: ToolsService
  ) {
  }

  findForVocabulary(idLevel: string){
    return this.http.get(`${this.toolsSrv.getApiTargetEndpoint()}words/level/${idLevel}`).toPromise();
  }

  findAllByLevel(idLevel: string) {
    return this.http.get(`${this.toolsSrv.getApiTargetEndpoint()}words/word/level/${idLevel}`).toPromise();
  }

  search(params: {
    query?: string,
    filters?: any
  }) {
    return this.http.post(`${this.toolsSrv.getApiTargetEndpoint()}words/dashboard`, params).toPromise();
  }
}
